module.exports = __webpack_public_path__ + "bradavice_3_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/bradavice_3_after.jpg
// module id = 933
// module chunks = 0